import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import Product5 from "../components/Product5";
import Nodata from "../components/NoData";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";


export default function Review() {
    const { t } = useTranslation();
    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [request] = useAxios();

    const [posReviewCnt, setPsReviewCnt] = useState(0);
    const [endReviewCnt, setEndReviewCnt] = useState(0);
    

    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMySaleeReviewListAPI", {
        });

        if(response.data.resultCode === 200){

            console.log(response.data.result.resultList)
            setDataList(response.data.result.resultList.filter((el) => el.reviewAt === "N"))
            setPsReviewCnt(response.data.result.resultList.filter((el) => el.reviewAt === "N").length)
            setEndReviewCnt(response.data.result.resultList.filter((el) => el.reviewAt === "Y").length)
            setData(response.data.result);          
                  
        }
    };
    useEffect(() => {
        fetchData();        
      }, []);

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={t(`Message.my_goods_review_list_title`)}/>
                <div className="tabArea">
                    <Link to="/Review" className="tabBtn active">{t(`Message.my_goods_review_list_tab1` , {reviewTargetCnt : posReviewCnt})}</Link>
                    <Link to="/ReviewFin" className="tabBtn">{t(`Message.my_goods_review_list_tab2` , {reviewEndCnt : endReviewCnt})}</Link>
                </div>
            </div>

            <div className="hdTabContWr">
                {dataList && dataList.length === 0?(
                <div className="floatCenter">
                    <Nodata text={t(`Message.my_goods_review_target_list_empty`)}/>
                </div> 
             ):(        
                <ul className="reviewList">
                    {dataList && dataList.map((obj, index) => (
                    <li key={index}>
                        <Product5 
                            type="type15"
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}                           
                            prodName={obj.goodsNm}
                            option={obj.firstOptnNm+ " "+ obj.firstOptnValue + " X "+  obj.orderQy}
                            deadline={obj.orderDt}
                            obj = {obj}
                        />
                        <Link to={"/ReviewWrite/"+obj.orderDetailSn} className="btn40 bdd">{t(`Message.my_goods_review_target_list_reg_btn`)}</Link>
                    </li>
                    ))}                         
                </ul>
            )}
            </div>
        </div>
    );
};
